// extracted by mini-css-extract-plugin
module.exports = {"headerNavBack":"ModifiersHeader__headerNavBack___3pSUE"};